module.exports = __webpack_public_path__ + "media/images/lb/544-702831809388d675152773a1512a7842.svg";